import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withTranslation } from 'react-i18next';
import { CSSTransition } from 'react-transition-group';
import { cambiarStringApp } from '../../actions';
import imageBlog500 from '../../assets/images/blog-administracion-sistemas-programacion-500.jpg';
import imageBlog1000 from '../../assets/images/blog-administracion-sistemas-programacion-1000.jpg';
import imageBlog2000 from '../../assets/images/blog-administracion-sistemas-programacion-2000.jpg';
import imageBlog4000 from '../../assets/images/blog-administracion-sistemas-programacion-4000.jpg';
import imageBlog6000 from '../../assets/images/blog-administracion-sistemas-programacion-6000.jpg';
import imageBlog8000 from '../../assets/images/blog-administracion-sistemas-programacion-8000.jpg';
import './Header.css';

class Header extends Component {
  constructor(props) {
    super(props);

    this.header = React.createRef();
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll = () => {
    // pageYOffset is a read-only window property that returns the number of pixels the document has been scrolled vertically, scrollY is the exactly same thing
    // The main difference is that there is better cross-browser compatibility for pageYOffset than scrollY so it's safe to just stick with pageYOffset
    // But note that neither is supported in Internet Explorer < 9
    // console.log(window.scrollY);
    // console.log(window.pageYOffset);

    if (this.header.current !== null) {
      if (window.innerWidth < 360) {
        if (window.pageYOffset > 136) { this.header.current.classList.add('headOpaca'); }
        if (window.pageYOffset <= 136) { this.header.current.classList.remove('headOpaca'); }
      } else if (window.innerWidth >= 360 && window.innerWidth < 400) {
        if (window.pageYOffset > 158) { this.header.current.classList.add('headOpaca'); }
        if (window.pageYOffset <= 158) { this.header.current.classList.remove('headOpaca'); }
      } else if (window.innerWidth >= 400 && window.innerWidth < 480) {
        if (window.pageYOffset > 179) { this.header.current.classList.add('headOpaca'); }
        if (window.pageYOffset <= 179) { this.header.current.classList.remove('headOpaca'); }
      } else if (window.innerWidth >= 480 && window.innerWidth < 640) {
        if (window.pageYOffset > 221) { this.header.current.classList.add('headOpaca'); }
        if (window.pageYOffset <= 221) { this.header.current.classList.remove('headOpaca'); }
      } else if (window.innerWidth >= 640 && window.innerWidth < 768) {
        if (window.pageYOffset > 316) { this.header.current.classList.add('headOpaca'); }
        if (window.pageYOffset <= 316) { this.header.current.classList.remove('headOpaca'); }
      } else if (window.innerWidth >= 768 && window.innerWidth < 900) {
        if (window.pageYOffset > 380) { this.header.current.classList.add('headOpaca'); }
        if (window.pageYOffset <= 380) { this.header.current.classList.remove('headOpaca'); }
      } else if (window.innerWidth >= 900 && window.innerWidth < 1024) {
        if (window.pageYOffset > 405) { this.header.current.classList.add('headOpaca'); }
        if (window.pageYOffset <= 405) { this.header.current.classList.remove('headOpaca'); }
      } else if (window.innerWidth >= 1024 && window.innerWidth < 1280) {
        if (window.pageYOffset > 343) { this.header.current.classList.add('headOpaca'); }
        if (window.pageYOffset <= 343) { this.header.current.classList.remove('headOpaca'); }
      } else if (window.innerWidth >= 1280 && window.innerWidth < 1600) {
        if (window.pageYOffset > 447) { this.header.current.classList.add('headOpaca'); }
        if (window.pageYOffset <= 447) { this.header.current.classList.remove('headOpaca'); }
      } else if (window.innerWidth >= 1600 && window.innerWidth < 1920) {
        if (window.pageYOffset > 575) { this.header.current.classList.add('headOpaca'); }
        if (window.pageYOffset <= 575) { this.header.current.classList.remove('headOpaca'); }
      } else if (window.innerWidth >= 1920 && window.innerWidth < 2560) {
        if (window.pageYOffset > 693) { this.header.current.classList.add('headOpaca'); }
        if (window.pageYOffset <= 693) { this.header.current.classList.remove('headOpaca'); }
      } else if (window.innerWidth >= 2560 && window.innerWidth < 3200) {
        if (window.pageYOffset > 748) { this.header.current.classList.add('headOpaca'); }
        if (window.pageYOffset <= 748) { this.header.current.classList.remove('headOpaca'); }
      } else if (window.innerWidth >= 3200 && window.innerWidth < 3840) {
        if (window.pageYOffset > 939) { this.header.current.classList.add('headOpaca'); }
        if (window.pageYOffset <= 939) { this.header.current.classList.remove('headOpaca'); }
      } else if (window.innerWidth >= 3840 && window.innerWidth < 5120) {
        if (window.pageYOffset > 1130) { this.header.current.classList.add('headOpaca'); }
        if (window.pageYOffset <= 1130) { this.header.current.classList.remove('headOpaca'); }
      } else if (window.innerWidth >= 5120 && window.innerWidth < 7680) {
        if (window.pageYOffset > 1175) { this.header.current.classList.add('headOpaca'); }
        if (window.pageYOffset <= 1175) { this.header.current.classList.remove('headOpaca'); }
      } else if (window.innerWidth >= 7680 && window.innerWidth < 8840) {
        if (window.pageYOffset > 1895) { this.header.current.classList.add('headOpaca'); }
        if (window.pageYOffset <= 1895) { this.header.current.classList.remove('headOpaca'); }
      } else if (window.innerWidth >= 8840) {
        if (window.pageYOffset > 1975) { this.header.current.classList.add('headOpaca'); }
        if (window.pageYOffset <= 1975) { this.header.current.classList.remove('headOpaca'); }
      }
    }

    /*
    Para saber cuando llego al final de la página
    const windowHeight = "innerHeight" in window ? window.innerHeight : document.documentElement.offsetHeight;
    const { body } = document;
    const html = document.documentElement;
    const docHeight = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
    const windowBottom = Math.round(windowHeight + window.pageYOffset);
    if (windowBottom >= docHeight) {
      console.log('OK');
    } else {
      console.log('KO');
    }
    */
  }

  handleClickBotonMenu = () => {
    this.props.cambiarStringApp('menuVisible', !this.props.menuVisible);
  }

  renderBoton() {
    if (this.props.menuVisible === true) { return <i className="fas fa-times" style={{ marginLeft: '7px' }} />; }

    return <i className="fas fa-bars" />;
  }

  render() {
    const { t } = this.props;

    return (
      <>
        <nav className="contenedor head" ref={this.header}>
          <a className="col-pxxxl-25 col-pxxl-16 col-pxl-6 col-pl-6 col-pm-3 col-ps-8 col-pxs-8 col-pxxs-8 col-xxl-6 col-xl-6 col-l-6 col-m-6 col-s-8 col-xs-8 col-xxs-8" href={process.env.REACT_APP_URL_HOME} title={t('titleLogo')}><img alt={t('titleLogo')} className="imgLogo" src="https://antarie.com/images/logo.png" title={t('titleLogo')} /></a>

          <CSSTransition classNames="moverCabeceraDerch" in={this.props.menuVisible} timeout={{ appear: 0, enter: 500, exit: 500 }}>
            <div className="col-pxxxl-25 col-pxxl-16 col-pxl-14 col-pl-14 col-pm-13 col-ps-8 col-pxs-8 col-pxxs-8 col-xxl-6 col-xl-6 col-l-6 col-m-6 col-s-4 col-xs-4 col-xxs-4 menuCabecera">
              <a className="hidden-xxs hidden-xs hidden-s hidden-m hidden-l hidden-xl hidden-xxl hidden-pxxs hidden-pxs hidden-ps hidden-pm textoPieG linkAzulAzulClaro margenDerechaBig" href={process.env.REACT_APP_URL_DESCUBRE_ANTARIE} title={t('link.descubreAntarie')}>{t('link.descubreAntarie')}</a>
              <a className="hidden-xxs hidden-xs hidden-s hidden-m hidden-l hidden-xl hidden-xxl hidden-pxxs hidden-pxs hidden-ps textoPieG linkAzulAzulClaro margenDerechaBig" href={process.env.REACT_APP_URL_SOLUCIONES_SOFTWARE} title={t('link.solucionesSoftware')}>{t('link.solucionesSoftware')}</a>
              <a className="hidden-xxs hidden-xs hidden-s hidden-m hidden-l hidden-xl hidden-xxl hidden-pxxs hidden-pxs hidden-ps textoPieG linkAzulAzulClaro margenDerechaBig" href={process.env.REACT_APP_URL_DESARROLLO_WEB} title={t('link.desarrolloWeb')}>{t('link.desarrolloWeb')}</a>
              <a className="hidden-xxs hidden-xs hidden-s hidden-m hidden-l hidden-xl hidden-xxl hidden-pxxs hidden-pxs hidden-ps textoPieG linkAzulAzulClaro margenDerechaBig" href={process.env.REACT_APP_URL_DESARROLLO_APPS} title={t('link.desarrolloApps')}>{t('link.desarrolloApps')}</a>
              <a className="hidden-xxs hidden-xs hidden-s hidden-m hidden-l hidden-xl hidden-xxl hidden-pxxs hidden-pxs hidden-ps textoPieG linkAzulAzulClaro margenDerechaBig" href={process.env.REACT_APP_URL_MACHINE_LEARNING} title={t('link.aiMachineLearning')}>{t('link.aiMachineLearning')}</a>
              <a className="hidden-xxs hidden-xs hidden-s hidden-m hidden-l hidden-xl hidden-xxl hidden-pxxs hidden-pxs hidden-ps textoPieG linkAzulAzulClaro margenDerechaBig" href={process.env.REACT_APP_URL_TRANSFORMACION_DIGITAL} title={t('link.transformacionDigital')}>{t('link.transformacionDigital')}</a>
              <a className="hidden-xxs hidden-xs hidden-s hidden-m hidden-l hidden-xl hidden-xxl hidden-pxxs hidden-pxs hidden-ps textoPieG linkAzulAzulClaro margenDerechaBigBig" href={process.env.REACT_APP_URL_MIGRACION_NUBE} title={t('link.migracionNube')}>{t('link.migracionNube')}</a>
              <button className="botonHead" name="botonMenu" onClick={this.handleClickBotonMenu} type="button" value="MostrarMenu">{this.renderBoton()}</button>
            </div>
          </CSSTransition>

          <div className="col-pxxxl-50 col-pxxl-32 col-pxl-20 col-pl-20 col-pm-16 col-ps-16 col-pxs-16 col-pxxs-16 col-xxl-12 col-xl-12 col-l-12 col-m-12 col-s-12 col-xs-12 col-xxs-12 cabeceraBordeInf">
            <hr className="cabecera" />
          </div>

          <div className="fLogo">&nbsp;</div>

          <CSSTransition classNames="moverfMenu" in={this.props.menuVisible} timeout={{ appear: 0, enter: 500, exit: 500 }}>
            <div className="hidden-ps hidden-pxs hidden-pxxs hidden-xxl hidden-xl hidden-l hidden-m hidden-s hidden-xs hidden-xxs fMenu">&nbsp;</div>
          </CSSTransition>
        </nav>

        <header>
          <h1 className="sr-only">{t(this.props.sr_only)}</h1>

          <div className="contenedor" style={{ position: 'absolute' }}>
            <div className="col-pxxxl-14 col-pxxl-8 col-pxl-5 col-pl-3 col-pm-2 col-ps-2 col-pxs-3 col-pxxs-2 col-xxl-1 col-xl-1 col-l-1 col-m-2 col-s-2 col-xs-2 col-xxs-2">&nbsp;</div>
            <div className="col-pxxxl-36 col-pxxl-24 col-pxl-15 col-pl-17 col-pm-14 col-ps-14 col-pxs-13 col-pxxs-14 col-xxl-11 col-xl-11 col-l-11 col-m-10 col-s-10 col-xs-10 col-xxs-10 textoCabecera">
              <p className="hidden-ps hidden-pxs hidden-pxxs hidden-xxl hidden-xl hidden-l hidden-m hidden-s hidden-xs hidden-xxs fontCabecera fontBold">{t(this.props.cabecera_titulo)}</p>
              <p className="hidden-pxxxl hidden-pxxl hidden-pxl hidden-pl hidden-pm hidden-xl hidden-l hidden-m hidden-s hidden-xs hidden-xxs fontCabecera fontBold">{t(this.props.cabecera_titulo_s)}</p>
              <p className="hidden-pxxxl hidden-pxxl hidden-pxl hidden-pl hidden-pm hidden-ps hidden-pxs hidden-pxxs hidden-xxl fontCabecera fontBold">{t(this.props.cabecera_titulo_xs)}</p>
              <p className="fontSubCabecera">{t(this.props.cabecera_subtitulo)}</p>
            </div>
          </div>

          <div className="divImgCabecera">
            <picture>
              <source className="imgCabecera" media="(min-width: 6000px)" srcSet={imageBlog8000} title={t('cabecerasTitulos.portada')} />
              <source className="imgCabecera" media="(min-width: 4000px)" srcSet={imageBlog6000} title={t('cabecerasTitulos.portada')} />
              <source className="imgCabecera" media="(min-width: 2000px)" srcSet={imageBlog4000} title={t('cabecerasTitulos.portada')} />
              <source className="imgCabecera" media="(min-width: 1000px)" srcSet={imageBlog2000} title={t('cabecerasTitulos.portada')} />
              <source className="imgCabecera" media="(min-width: 500px)" srcSet={imageBlog1000} title={t('cabecerasTitulos.portada')} />
              <img alt={t('cabecerasTitulos.portada')} className="imgCabecera" src={imageBlog500} title={t('cabecerasTitulos.portada')} />
            </picture>
          </div>
        </header>

        <div className="distanciaBody" />
      </>
    );
  }
}

const mapStateToProps = ({ app }) => {
  const { cabecera_titulo, cabecera_titulo_s, cabecera_titulo_xs, cabecera_subtitulo, sr_only, menuVisible } = app;

  return { cabecera_titulo, cabecera_titulo_s, cabecera_titulo_xs, cabecera_subtitulo, sr_only, menuVisible };
};

// Esta funciona pero la siguiente es más elegante
// export default connect(mapStateToProps)(withTranslation()(Header));
export default compose(
  connect(mapStateToProps, { cambiarStringApp }),
  withTranslation('common')
)(Header);
